"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
_export_star(require("./review-report"), exports);
_export_star(require("./review-report-history"), exports);
_export_star(require("./review-cycle"), exports);
_export_star(require("./review-form-assignment"), exports);
_export_star(require("./review-form"), exports);
_export_star(require("./review-report-awaiting-approval"), exports);
_export_star(require("./review-template"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
